import { typedQueryClient, useTypedQuery } from "hooks/useTypedQuery";
import { LocationLicenseOverviewKeys } from "modules/LocationLicenseOverview/queryKeys";

import type { PaginatedInvoicesType } from "modules/LocationLicenseOverview/queryKeys";

export const usePaginatedInvoices = () => useTypedQuery({ queryKey: LocationLicenseOverviewKeys.paginatedInvoices, initialData: { data: [] } }).data;
export const setPaginatedInvoices = (data: PaginatedInvoicesType) => typedQueryClient.setQueryData(LocationLicenseOverviewKeys.paginatedInvoices, data);
export const getPaginatedInvoices = () => typedQueryClient.getQueryData(LocationLicenseOverviewKeys.paginatedInvoices) || { data: [] };
